export default __webpack_public_path__ + "static/media/planner_base_image.eeba2779.jpg";